import './thesaurus-term-chooser-list.scss'

import { defineComponent, PropType } from 'vue';

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { FormApi } from 'final-form';
import { get, set } from 'lodash'
import { ThesaurusTermChooser } from '../..';
import { EnhancedTextArea } from '../enhanced-text-area';

let vForKey: number = 0;

export const ThesaurusTermChooserList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEnhancedTextArea: EnhancedTextArea,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: {
        // The identifer of the thesaurus in the database (ex : material, typeOfAlteration, etc...)
        thesaurusIdentifiers: {},
        // A text corresponding to the value undefined, added on top of the options
        placeholders: {},
        name: { type: String, required: true },
        subPaths: { type: Array as PropType<string[]> },
        precisionSubPath: { type: String },
        titles: {},
        form: {},
        readOnly: {},
    },
    template: require('./thesaurus-term-chooser-list.html'),
    data() {
        return {
            // Icons
            trashIcon: faTrash,
            plusIcon: faPlusCircle,
        }
    },
    computed: {
        entriesList(): any[] {
            // entries can be undefined
            const { values } = (this.form as FormApi).getState();

            let entries = get(values, this.name);
            if (!entries) {
                entries = [];
                set(values, this.name, entries);
            }
            return entries;
        },
    },
    methods: {
        entryFieldName(entryIndex: number, subPathIndex: number) {
            const subPathToAppend: string = this.subPaths?.[subPathIndex] ? `.${this.subPaths[subPathIndex]}` : '';
            return `${this.name}[${entryIndex}${subPathToAppend}`
        },
        entryPrecisionFieldName(index: number) {
            const subPathToAppend: string = this.precisionSubPath ? `.${this.precisionSubPath}` : '';
            return `${this.name}[${index}${subPathToAppend}`
        },
        entryPrecisionValue(entry) {
            return this.precisionSubPath ? get(entry, this.precisionSubPath) : undefined
        },
        vForKey() {
            vForKey++;
            return vForKey;
        },
        addEntry() {
            this.entriesList.push({
                id: this.vForKey(),
                typeIntervention: null
            })
        },
        deleteEntry(index: number) {
            this.entriesList.splice(index, 1)
        },
    },
})
